import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import HomePage from './HomePage';
import BlogArticleFreeWebsiteUk from './BlogArticleFreeWebsiteUk';
import GuidesHubPage from './GuidesHubPage';
import GuideArticlePage from './GuideArticlePage';
import WebsiteTaxCalculatorPage from './WebsiteTaxCalculatorPage';
import CheckYourSeoPage from './CheckYourSeoPage';
import AccessibilityCheckPage from './AccessibilityCheckPage';
import ReadingTimeToolPage from './ReadingTimeToolPage';
import ScopeEstimatorPage from './ScopeEstimatorPage';
import CompetitorTrackerPage from './CompetitorTrackerPage';
import SerpOverviewPage from './SerpOverviewPage';
import KeywordsExplorerPage from './KeywordsExplorerPage';
import WebsiteCrawlerPage from './WebsiteCrawlerPage';
import BacklinkCheckerPage from './BacklinkCheckerPage';
import LocationsHubPage from './LocationsHubPage';
import LocalAreaPage from './LocalAreaPage';
import TradesHubPage from './TradesHubPage';
import TradesNichePage from './TradesNichePage';
import TradesAreaPage from './TradesAreaPage';
import EcommerceWebAppsPage from './EcommerceWebAppsPage';
import ServicePillarPage from './ServicePillarPage';
import NotFoundPage from './NotFoundPage';
import AnalyticsConsentLoader from './AnalyticsConsentLoader';
import SparkleCursor from './SparkleCursor';

const AdminPage = lazy(() => import('./AdminPage'));
const AdminLoginPage = lazy(() => import('./AdminLoginPage'));

const adminFallback = (
  <div className="min-h-screen flex items-center justify-center bg-gray-50 text-gray-600">
    Loading…
  </div>
);

function App() {
  return (
    <BrowserRouter>
      <SparkleCursor />
      <AnalyticsConsentLoader />
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/faq" element={<HomePage />} />
        <Route path="/services/:pillarSlug" element={<ServicePillarPage />} />
        <Route path="/services" element={<HomePage />} />
        <Route path="/ecommerce-web-apps" element={<EcommerceWebAppsPage />} />
        <Route path="/blog/free-websites-uk-builders" element={<BlogArticleFreeWebsiteUk />} />
        <Route path="/guides" element={<GuidesHubPage />} />
        <Route path="/guides/:slug" element={<GuideArticlePage />} />
        <Route path="/locations" element={<LocationsHubPage />} />
        <Route path="/locations/:slug" element={<LocalAreaPage />} />
        <Route path="/trades" element={<TradesHubPage />} />
        <Route path="/trades/:tradeSlug/:areaSlug" element={<TradesNichePage />} />
        <Route path="/trades/:slug" element={<TradesAreaPage />} />
        <Route path="/website-tax-calculator" element={<WebsiteTaxCalculatorPage />} />
        <Route path="/check-your-seo" element={<CheckYourSeoPage />} />
        <Route path="/accessibility-check" element={<AccessibilityCheckPage />} />
        <Route path="/reading-time-tool" element={<ReadingTimeToolPage />} />
        <Route path="/scope-estimator" element={<ScopeEstimatorPage />} />
        <Route path="/competitor-tracker" element={<CompetitorTrackerPage />} />
        <Route path="/serp-overview" element={<SerpOverviewPage />} />
        <Route path="/keywords-explorer" element={<KeywordsExplorerPage />} />
        <Route path="/website-crawler" element={<WebsiteCrawlerPage />} />
        <Route path="/backlink-checker" element={<BacklinkCheckerPage />} />
        <Route
          path="/admin-login"
          element={
            <Suspense fallback={adminFallback}>
              <AdminLoginPage />
            </Suspense>
          }
        />
        <Route
          path="/admin"
          element={
            <Suspense fallback={adminFallback}>
              <AdminPage />
            </Suspense>
          }
        />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
